import React from "react";
import { useNavigate } from "react-router-dom";
import { resetPassword } from "web/apis";
import { UserEmailCard } from "web/react/components/user-email-card";
import { Button } from "web/react/emo/button";
import { Heading } from "web/react/emo/heading";
import { Text } from "web/react/emo/text/text";
import { useToast } from "web/react/emo/toast/useToast";
import { VStack } from "web/react/emo/v-stack";
import { View } from "web/react/emo/view";
import analytics from "web/script/analytics/analytics";
import { gettext } from "web/script/modules/django-i18n";
import styles from "./forgot-password-email-sent-screen.module.css";

export interface ForgotPasswordEmailSentScreenProps {
    email: string;
}

export const ForgotPasswordEmailSentScreen = ({
    email,
}: ForgotPasswordEmailSentScreenProps): JSX.Element => {
    const navigate = useNavigate();
    const toast = useToast();

    async function onClick(): Promise<void> {
        analytics.event("forgot_password_sent", "click", "resend_email_link");

        try {
            await resetPassword(email);
            toast({ message: gettext("account.email_sent_check_inbox.label") });
        } catch (e) {
            analytics.event("forgot_password_sent", "error", "resend_email_link");
        }
    }

    return (
        <>
            <View className={styles.wrapper}>
                <VStack spacing="md">
                    <Heading textStyle={"headline-v2"} as="h1">
                        {gettext("account.resend_reset_link.title")}
                    </Heading>
                    <Text textStyle={"body-3"}>
                        {gettext("account.resend_reset_link.desc", {
                            user_email_address: email,
                        })}
                    </Text>
                    <UserEmailCard email={email} onClick={() => navigate("/forgot-password")} />
                    <Text textStyle={"body-3"} color="secondary">
                        {gettext("account.no_email_received_reset_link.label")}
                    </Text>
                    <div>
                        <Button
                            width="full"
                            type="submit"
                            variant={"secondary"}
                            onClick={onClick}
                            title={gettext("account.resend_reset_link.cta")}
                            textStyle={"callout-v2"}
                            upperCase
                        />
                    </div>
                </VStack>
            </View>
        </>
    );
};
